<template>
  <button
    class="rail-btn-hover rail-btn-nowrap margin-left-xs"
    aria-label="open gift registry drawer"
    aria-haspopup="dialog"
    @click="handleOpenRegistrySlideout"
  >
    <i class="icon-28x28 registry-dark-large margin-right-xxs"></i>
    <span class="grid-x heavy-sm">Gift Registry</span>
  </button>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import useRegistrySlideout from '~/composables/features/useRegistrySlideout';
import { fireLinkTag } from '#shared/features/analytics/tagManager';

const { openRegistrySlideout } = useRegistrySlideout();

const handleOpenRegistrySlideout = () => {
  openRegistrySlideout();
  fireLinkTag({
    event_name: 'registry drawer open',
    link_name: 'registry drawer open',
  });
};
</script>
